import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { EncuestaDTO } from '../dto/encuesta/encuesta.dto';
import { RespuestaEncuestaDto } from '../dto/encuesta/respuesta-encuesta.dto';
import { PreguntaDTO } from '../dto/encuesta/preguntas.dto';

@Injectable({
  providedIn: 'root',
})
export class EncuestaService {
  private apiUrl = `${environment.apiUrl}/encuesta`;

  constructor(private http: HttpClient) {}

  getEncuentaByid(id: number): Observable<EncuestaDTO> {
    return this.http.get<EncuestaDTO>(`${this.apiUrl}/${id}`);
  }

  guardarRespuestas(id: number, data: RespuestaEncuestaDto[]): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/${id}`, data);
  }

  getListarEncuestas() {
    return this.http.get<EncuestaDTO[]>(`${this.apiUrl}/listado/all`);
  }

  getListarRespuestasEncuesta(data: any) {
    return this.http.post<RespuestaEncuestaDto[]>(`${this.apiUrl}/listado/respuestas`, data);
  }

  actualizarEncuesta(
    idEncuesta: number,
    encuesta: EncuestaDTO
  ): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${idEncuesta}`, encuesta);
  }

  crearPregunta(request: PreguntaDTO): Observable<PreguntaDTO> {
    return this.http.post<any>(`${this.apiUrl}/pregunta/crear`, request);
  }

  actualizarPregunta(
    idPregunta: number,
    request: PreguntaDTO
  ): Observable<PreguntaDTO> {
    return this.http.put<any>(`${this.apiUrl}/pregunta/${idPregunta}`, request);
  }
}
